var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-chip-container",
      class: {
        "chip-container--removable": _vm.removable,
        "chip-container--clearable": _vm.clearable,
      },
      attrs: { "data-filter-field": _vm.dataFilterField },
    },
    [
      _c(
        "CustomPopover",
        {
          ref: "customPopover",
          attrs: {
            icon: _vm.icon,
            label: _vm.getLabel(),
            "show-dropdown-arrow": false,
            "button-class":
              _vm.chipClass +
              (_vm.removable ? " chip--removable" : "") +
              (_vm.hasValue ? " chip--has-value" : ""),
            "show-form-footer": true,
            removable: _vm.removable,
            clearable: _vm.isClearable,
          },
          on: {
            "popover-change": _vm.onPopoverChange,
            clear: _vm.onPopoverClear,
            apply: _vm.onPopoverApply,
            "remove-click": _vm.onRemove,
            "clear-click": _vm.onClear,
          },
        },
        [
          _c("template", { slot: "content" }, [
            _c("div", { staticClass: "broadcast-composite-container" }, [
              _c("div", { staticClass: "broadcast-composite-field" }, [
                _c("label", { staticClass: "broadcast-composite-label" }, [
                  _vm._v(_vm._s(_vm.$t("auto.broadcast"))),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.broadcastValue,
                        expression: "broadcastValue",
                      },
                    ],
                    staticClass: "broadcast-composite-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.broadcastValue = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(_vm._s(_vm.$t("auto.select"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.broadcastOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-composite-field" }, [
                _c("label", { staticClass: "broadcast-composite-label" }, [
                  _vm._v(_vm._s(_vm.$t("auto.messageStatus"))),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.statusValue,
                        expression: "statusValue",
                      },
                    ],
                    staticClass: "broadcast-composite-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.statusValue = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(_vm._s(_vm.$t("auto.select"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.statusOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-composite-field" }, [
                _c("label", { staticClass: "broadcast-composite-label" }, [
                  _vm._v(_vm._s(_vm.$t("auto.replyStatus"))),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.answeredValue,
                        expression: "answeredValue",
                      },
                    ],
                    staticClass: "broadcast-composite-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.answeredValue = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(_vm._s(_vm.$t("auto.select"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.answeredOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }